module.exports = __webpack_public_path__ + "img/tears-joy.f3ee4211.png";